import { EdgeProps, getBezierPath, EdgeLabelRenderer, BaseEdge } from 'reactflow';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data
}: EdgeProps) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });

  const isNew = data?.isNew;
  const isDeletable = data?.deletable;
  const hovered = data?.hovered;

  // Determine edge color based on state
  let edgeColor = style?.stroke || '#DADADA';
  if (hovered && isDeletable) {
    edgeColor = '#ff4444'; // Red when hovered for deletion
  } else if (isNew) {
    edgeColor = '#4CAF50'; // Green for new edges
  }

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          ...style,
          stroke: edgeColor,
          strokeWidth: hovered ? 3 : isNew ? 2 : style?.strokeWidth || 1,
          cursor: hovered ? 'pointer' : 'default'
        }}
      />
      {hovered && isDeletable && (
        <EdgeLabelRenderer>
          <Box
            onClick={(e) => {
              e.stopPropagation();
              if (data?.onClick) {
                data.onClick(e);
              }
            }}
            sx={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              fontSize: 12,
              pointerEvents: 'all',
              backgroundColor: '#ff4444',
              borderRadius: '50%',
              width: 20,
              height: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              cursor: 'pointer',
              //   zIndex: 1000,
              '&:hover': {
                backgroundColor: '#ff2222'
              }
            }}
          >
            <CloseIcon sx={{ fontSize: 12 }} />
          </Box>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default CustomEdge;
